import { useClinic } from "client/clinics/hooks";

export const useDefaultCalendarId = () => {
  const clinic = useClinic();

  // 0 if no calendars have been created for the clinic
  return clinic.calendar_ids[0] ?? 0;
};
